<template>
  <div class="flex flex-col overflow-auto text-gray-700 bg-white shadow rounded-2xl divide-y-2 divide-slate-100">
    <div class="flex items-center justify-between divide-x-2 divide-slate-200">
      <div class="flex justify-between">
        <input v-model="q" @input="_emit" class="px-2 min-w-[100px] max-w-[150px] text-xl" placeholder="Search Here..." type="text">
        <button @click="resetSearch" class="px-3 h-[40px]"><i class="ion-md-close"></i></button>
      </div>
      <select v-model="search" @change="_emit" class="h-[40px] px-2 bg-white">
        <option value="-">-- ANY ---</option>
        <option v-for="(c, index) in columns" :key="index" :value="index">{{ c }}</option>
      </select>
    </div>

    <div class="flex items-center justify-between divide-x-2 divide-slate-200">
      <select v-model="sort" @change="_emit" class="w-[100px] flex-1 bg-white py-1">
        <option v-for="(s, sIndex) in sorts" :key="sIndex" :value="sIndex">{{ s }}</option>
      </select>

      <button v-if="order == 'asc'" @click="toggleOrder" class="px-2 py-1">ASC <i class="ion-md-arrow-up"></i></button>
      <button v-if="order == 'desc'" @click="toggleOrder" class="px-2 py-1">DESC <i class="ion-md-arrow-down"></i></button>
    </div>

    <div class="flex items-center justify-between divide-slate-200 divide-x-2">
      <select v-model="group" @change="_emit" v-if="groups.length != 0" class="w-[100px] flex-1 bg-white py-1">
        <option value="-">-- ALL ---</option>
        <option v-for="group in groups" :key="group.name" :value="group.id">{{ group.name }}</option>
      </select>

      <select v-model="status" @change="_emit" v-if="statuses.length != 0" class="w-[100px] flex-1 bg-white py-1">
        <option value="-">-- ALL ---</option>
        <option v-for="iStatus in statuses" :key="iStatus" :value="iStatus">{{ iStatus }}</option>
      </select>

      <select v-model="tag" @change="_emit" v-if="tags.length != 0" class="w-[100px] flex-1 bg-white py-1">
        <option value="-">-- ALL ---</option>
        <option v-for="tag in tags" :key="tag" :value="tag">{{ tag }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchSort',

  props: {
    defaults: { type: Object, required: false, default: {q: '', search: '-', sort: 'id', order: 'asc', group: '-', tag: '-', status: '-' } },
    columns: { type: Object, required: true, default: {'-': '-- ANY --'} },
    sorts: { type: Object, required: true, default: {} },
    groups: { type: Array, required: true, default: [] },
    tags: { type: Array, required: false, default: [] },
    statuses: { type: Array, required: false, default: [] },
  },

  data() {
    return {
      q: '',
      search: '-',
      sort: 'id',
      order: 'asc',
      group: '-',
      tag: '-',
      status: '-',
      routeKey: null,
    };
  },

  mounted() {
    const key = this.$route.name || this.$route.path;

    this.routeKey = key;

    const saved = this.$store.state.searchSort[key];

    if (saved) {
      this.q = saved.q;
      this.search = saved.search;
      this.sort = saved.sort;
      this.order = saved.order;
      this.group = saved.group;
      this.tag = saved.tag;
      this.status = saved.status;

      this._emit()
    } else {
      this.resetSearch(false);
    }
  },

  methods: {
    _emit() {
      const key = this.$route.name || this.$route.path;

      this.$store.state.searchSort[key] = {q: this.q, search: this.search, sort: this.sort, order: this.order, group: this.group, tag: this.tag, status: this.status};
      
      this.$emit('update', this.q, this.search, this.sort, this.order, this.group, this.tag, this.status);
    },

    resetSearch(emit = true) {
      this.q = this.defaults.q;
      this.search = this.defaults.search;
      this.sort = this.defaults.sort;
      this.order = this.defaults.order;
      this.group = this.defaults.group;
      this.tag = this.defaults.tag;
      this.status = this.defaults.status;

      const key = this.$route.name || this.$route.path;

      delete this.$store.state.searchSort[key];

      if (emit) this._emit();
    },

    toggleOrder() {
      if (this.order == 'asc') this.order = 'desc';
      else if (this.order == 'desc') this.order = 'asc';
      this._emit();
    },
  },

  beforeUnmount() {
    const currentKey = this.$route.name || this.$route.path;

    if (this.routeKey && this.routeKey !== currentKey) {
      delete this.$store.state.searchSort[this.routeKey];
    }
  },
}
</script>
